import axios from "../http-config/axiosConfig";

const logsApi = {
	getLogsAsync: async () => {
		const { data } = await axios.get(`/Logs`);
		return data.result;
	},
};

export default logsApi;
